import {
  observable, flow, computed, makeObservable, action,
} from 'mobx';

import NetworksReviewsApi from '../api/networks_review';
import BaseStore from './BaseStore';
import { SourceOptionsFilter, StatusOptionsFilter } from '../components/NetworksReviews/constants/constants';

const PER_PAGE_LIMIT = 10;

class NetworksReviewsStore extends BaseStore {
  isLoading = false;
  reviews = [];
  schools = [];
  networkId = '';
  sourceFilter = SourceOptionsFilter.AllSource;
  statusFilter = StatusOptionsFilter.AllStatus;
  schoolSelected = '';
  total = 0;
  page = 1;

  constructor() {
    super();

    makeObservable(this, {
      isLoading: observable,
      reviews: observable,
      schools: observable,
      total: observable,
      pageCount: computed,
      networkId: observable,
      page: observable,
      sourceFilter: observable,
      statusFilter: observable,
      schoolSelected: observable,
      setSourceFilter: action.bound,
      setStatusFilter: action.bound,
      setSchoolSelected: action.bound,
      setPage: action.bound,
    });
  }

  getReviews = flow(function* (id) {
    this.isLoading = true;
    this.networkId = id;

    try {
      const { data: { items, total } } = yield NetworksReviewsApi.getReviews({
        limit: PER_PAGE_LIMIT,
        page: this.page,
        networkId: this.networkId,
        status: this.statusFilter,
        source: this.sourceFilter,
        schoolId: this.schoolSelected.value,
      });
      this.reviews = items;
      this.total = total;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.response.data.errorMessages);
    } finally {
      this.isLoading = false;
    }
  });

  getSchools = flow(function* (id) {
    this.isLoading = true;
    this.networkId = id;
    try {
      const { data } = yield NetworksReviewsApi.getSchools({ networkId: this.networkId });
      this.schools = data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.response.data.errorMessages);
    } finally {
      this.isLoading = false;
    }
  });

  updateSearch() {
    this.getReviews(this.networkId);
  }

  setSourceFilter(filter) {
    this.sourceFilter = filter;
    this.updateSearch();
  }

  setStatusFilter(filter) {
    this.statusFilter = filter;
    this.updateSearch();
  }

  setSchoolSelected(filter) {
    this.schoolSelected = filter;
    this.updateSearch();
  }

  setPage(page) {
    if (page !== this.page) {
      this.page = page;
      this.updateSearch();
    }
  }

  get pageCount() {
    return Math.ceil(this.total / PER_PAGE_LIMIT);
  }
}

export default new NetworksReviewsStore();
